import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VideoStateService {
  private pausedByUser = false;

  setPausedByUser(isPaused: boolean): void {
    this.pausedByUser = isPaused;
  }

  wasPausedByUser(): boolean {
    return this.pausedByUser;
  }
}


